import request from '@/utils/request';

export const FETCH_ONBOARDING_REQUEST = 'FETCH_ONBOARDING_REQUEST';
export const FETCH_ONBOARDING_SUCCESS = 'FETCH_ONBOARDING_SUCCESS';
export const FETCH_ONBOARDING_FAILURE = 'FETCH_ONBOARDING_FAILURE';

export const UPDATE_ONBOARDING_REQUEST = 'UPDATE_ONBOARDING_REQUEST';
export const UPDATE_ONBOARDING_SUCCESS = 'UPDATE_ONBOARDING_SUCCESS';
export const UPDATE_ONBOARDING_FAILURE = 'UPDATE_ONBOARDING_FAILURE';

export const COMPLETE_GOAL_REQUEST = 'COMPLETE_GOAL_REQUEST';
export const COMPLETE_GOAL_SUCCESS = 'COMPLETE_GOAL_SUCCESS';
export const COMPLETE_GOAL_FAILURE = 'COMPLETE_GOAL_FAILURE';

export const DISMISS_ONBOARDING_REQUEST = 'DISMISS_ONBOARDING_REQUEST';
export const DISMISS_ONBOARDING_SUCCESS = 'DISMISS_ONBOARDING_SUCCESS';
export const DISMISS_ONBOARDING_FAILURE = 'DISMISS_ONBOARDING_FAILURE';

export const fetchOnboarding = () => async dispatch => {
  dispatch({ type: FETCH_ONBOARDING_REQUEST });
  try {
    const response = await request({ path: '/v1/cf360_onboarding' });
    const payload = response?.onboarding ?? response?.data ?? response;
    dispatch({ type: FETCH_ONBOARDING_SUCCESS, payload });
    return payload;
  } catch (error) {
    dispatch({ type: FETCH_ONBOARDING_FAILURE, payload: error.message });
    throw error;
  }
};

export const updateOnboarding = data => async dispatch => {
  dispatch({ type: UPDATE_ONBOARDING_REQUEST });
  try {
    const response = await request({
      path: '/v1/cf360_onboarding',
      method: 'PUT',
      body: data
    });
    dispatch({ type: UPDATE_ONBOARDING_SUCCESS, payload: response.data || response.onboarding });
    return response;
  } catch (error) {
    dispatch({ type: UPDATE_ONBOARDING_FAILURE, payload: error.message });
    throw error;
  }
};

export const completeGoal = goalKey => async dispatch => {
  dispatch({ type: COMPLETE_GOAL_REQUEST });
  try {
    const response = await request({
      path: '/v1/cf360_onboarding/complete_goal',
      method: 'POST',
      body: { goal_key: goalKey }
    });
    dispatch({ type: COMPLETE_GOAL_SUCCESS, payload: response.data || response.onboarding });
    return response;
  } catch (error) {
    dispatch({ type: COMPLETE_GOAL_FAILURE, payload: error.message });
    throw error;
  }
};

export const dismissOnboarding = () => async dispatch => {
  dispatch({ type: DISMISS_ONBOARDING_REQUEST });
  try {
    const response = await request({
      path: '/v1/cf360_onboarding/dismiss',
      method: 'POST'
    });
    dispatch({ type: DISMISS_ONBOARDING_SUCCESS, payload: response.data || response.onboarding });
    return response;
  } catch (error) {
    dispatch({ type: DISMISS_ONBOARDING_FAILURE, payload: error.message });
    throw error;
  }
};
